import { all } from 'redux-saga/effects';
import loginSaga from './login/sagas';
import forgotPasswordSaga from './forgotPassword/sagas';
import resetPasswordSaga from './resetPassword/sagas';
import changePasswordSaga from './changePassword/sagas';
import registerSaga from './register/sagas';
import profileSaga from './profile/sagas';
import langsSaga from './langs/sagas';
import quizSaga from './quiz/sagas';
import prewievSaga from './quiz/preview/sagas';
import calendarSaga from './calendar/sagas';
import hatchSaga from './calendar/hatch/sagas';
import prizesSaga from './calendar/navigation/prizes/sagas';
import localizationSaga from './localization/sagas';
import adminSaga from './admin/sagas';
import statisticsSaga from './statistics/quiz/sagas';
import questionsSaga from './statistics/questions/sagas';
import calendarCountryStatisticsSaga from './statistics/country/sagas';
import linksTrackingSaga from './statistics/linksTracking/sagas';
import statisticsDashBoardSaga from './statistics/dashboard/sagas';
import playersSaga from './quiz/players/sagas';
import usersSaga from './user/sagas';
import rolesSaga from './role/sagas';
import permissionsSaga from './permissionManagement/sagas';
import roundsSaga from './quiz/rounds/sagas';
import settingsSaga from './quiz/settings/sagas';
import timerSaga from './player/quiz/sagas';
import hatchGameSaga from './player/calendar/sagas';
import regFormSaga from './player/register/sagas';
import calendarStatisticsSaga from './statistics/calendar/sagas';
import watchLinksTrackingCalendar from './statistics/calendar/linksTracking/sagas';
import appearanceSaga from './appearance/sagas';
import appearanceBackgroundSaga from './appearance/backgrounds/sagas';
import appearanceLogoSaga from './appearance/logos/sagas';
import fontsSga from './fonts/sagas';
import shareSaga from './sharing/sagas';
import setGlobal from './global/sagas';
import watchSendDiploma from './sendMail/sagas';
import watchEditorDiploma from './diploma/sagas';
import watchSendFile from './uploadFile/sagas';
import watchProxyImage from './proxyImage/sagas';
import watchProxyFonts from './proxyFont/sagas';
import watchLeaderBoard from './leaderBoard/sagas';
import watchLeaderBoardSettings from './leaderBoardSettings/sagas';
import watchSendIdentifier from './userIdentifier/sagas';
import watchProxyHeaderImage from './proxyHeaderImage/sagas';

import watchActionBuffer from './actionBuffer/sagas';
import watchSendApi from './apiSettings/sagas';
import watchTenantStatistics from './tenantStatistics/sagas';
import dataManagementSaga from './dataManagement/sagas';

export default function* rootSaga (){
    yield all([
        watchTenantStatistics(),
        watchActionBuffer(),
        watchSendApi(),
        watchProxyHeaderImage(),
        timerSaga(),
        quizSaga(),
        playersSaga(),
        usersSaga(),
        rolesSaga(),
        permissionsSaga(),
        roundsSaga(),
        prizesSaga(),
        settingsSaga(),
        calendarCountryStatisticsSaga(),
        loginSaga(),
        forgotPasswordSaga(),
        resetPasswordSaga(),
        changePasswordSaga(),
        profileSaga(),
        registerSaga(),
        statisticsSaga(),
        questionsSaga(),
        linksTrackingSaga(),
        statisticsDashBoardSaga(),
        langsSaga(),
        regFormSaga(),
        prewievSaga(),
        calendarSaga(),
        hatchSaga(),
        hatchGameSaga(),
        localizationSaga(),
        calendarStatisticsSaga(),
        watchLinksTrackingCalendar(),
        appearanceSaga(),
        appearanceBackgroundSaga(),
        appearanceLogoSaga(),
        fontsSga(),
        shareSaga(),
        adminSaga(),
        setGlobal(),
        watchSendDiploma(),
        watchEditorDiploma(),
        watchSendFile(),
        watchProxyImage(),
        watchProxyFonts(),
        watchLeaderBoard(),
        watchLeaderBoardSettings(),
        watchSendIdentifier(),
        dataManagementSaga()
    ]);
}
